import { Button, Container, Group, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import styles from './ErrorPage.module.css';
import { pagesTestIds } from '../testids';

/**
 * 403 — access-denied page. Rendered when a user navigates to a route gated by
 * a capability they do not hold ( see `GatedRoute` ). Replaces the previous
 * "render an empty list" behavior for no-read users ( TV1-1867 ).
 */
const Forbidden403 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation( 'error' );
  return (
    <Container className={styles.root} data-testid={pagesTestIds.forbidden403}>
      <div className={styles.label}>403</div>
      <Title className={styles.title}>
        {t( 'forbidden_page_title', 'Sin acceso' )}
      </Title>
      <Text c="dimmed" size="lg" ta="center" className={styles.description}>
        {t( 'forbidden_page_message', 'No tenés acceso a esta sección. Si creés que es un error, contactá a un administrador de tu cuenta.' )}
      </Text>
      <Group justify="center">
        <Button variant="subtle" size="md" onClick={() => navigate( '/', { replace: true })}>
          {t( 'back_button', 'Volver' )}
        </Button>
      </Group>
    </Container>
  );
};

export default Forbidden403;
